import React, { useEffect, useState } from "react"

export const Fortune = ({ text = "" }) => {
    const [time, setTime] = useState(new Date().getMinutes());

    useEffect(() => {
        const interval = setInterval(() => setTime(new Date().getMinutes()), 1000);
        return () => {
            clearInterval(interval);
        };
    }, []);

    const fortunes = [
        'BRING HIM THE PHOTO',
        'YOU WILL DIE ALONE',
        'YOU ARE THROWING YOUR LIFE AWAY',
        'GO OUTSIDE!',
        'ASK AGAIN LATER',
        'THINK FOR YOURSELF',
        'QUESTION AUTHORITY',
        'YOU ARE WORSHIPING A SUN GOD',
        'DON\'T LEAVE THE HOUSE TODAY',
        'GIVE UP!',
        'MARRY AND REPRODUCE',
        'STAY ASLEEP',
        'WAKE UP',
        'WE WILL ALL DIE ONE DAY',
        'LOOK TO LA LUNA',
        'STEVEN LIVES',
        'MEET STRANGERS WITHOUT PREJUDICE',
        'A HANGED MAN WILL BRING YOU NO LUCK TODAY',
        'WHAT DO YOU WANT TO DO TODAY?',
        'YOU ARE DARK INSIDE',
        'HAVE YOU SEEN THE EXIT?',
        'GET A BABY PET IT WILL CHEER YOU UP.',
        'YOUR PRINCESS IS IN ANOTHER CASTLE.',
        'YOU ARE PLAYING IT WRONG GIVE ME THE CONTROLLER',
        'TRUST GOOD PEOPLE',
        'LIVE TO DIE.',
        'WHEN LIFE GIVES YOU LEMONS REROLL!',
        'WELL THAT WAS WORTHLESS',
        'I FEEL ASLEEP!',
        'MAY YOUR TROUBLES BE MANY',
        'YOUR OLD LIFE LIES IN RUIN',
        'ALWAYS LOOK ON THE BRIGHT SIDE',
        'YOU WERE BORN WRONG',
        'IT IS DANGEROUS TO GO ALONE',
        'YOU WILL NEVER BE FORGIVEN',
        'YOU HAVE NOBODY TO BLAME BUT YOURSELF',
        'ONLY A SINNER',
        'USE BOMBS WISELY',
        'NOBODY KNOWS THE TROUBLES YOU HAVE SEEN',
        'YOU LOOK FAT YOU SHOULD EXERCISE MORE',
        'FOLLOW THE ZEBRA',
        'WHY SO BLUE?',
        'THE DEVIL IN DISGUISE',
        'GO OUTSIDE',
        'ALWAYS YOUR HEAD IN THE CLOUDS',
        'STEVEN LIVES',
        'MEET STRANGERS WITHOUT PREJUDICE',
        'A HANGED MAN WILL BRING YOU NO LUCK TODAY',
        'WHAT DO YOU WANT TO DO TODAY?',
        'YOU ARE DARK INSIDE',
        'HAVE YOU SEEN THE EXIT?',
        'GET A BABY PET IT WILL CHEER YOU UP.',
        'YOUR PRINCESS IS IN ANOTHER CASTLE.',
        'YOU ARE PLAYING IT WRONG GIVE ME THE CONTROLLER',
        'TRUST GOOD PEOPLE',
        'LIVE TO DIE.',
        'WHEN LIFE GIVES YOU LEMONS REROLL!',
        'WELL THAT WAS WORTHLESS',
        'I FEEL ASLEEP!',
        'MAY YOUR TROUBLES BE MANY',
        'YOUR OLD LIFE LIES IN RUIN',
    ];
    
    return (
        <i>
            {fortunes[time]}
        </i>
    )
}
